import alertShow from '../alert/alertShow';

const productInCartRemove = () => {
    const productsInCart = document.querySelectorAll('.Product-in-cart');

    if(productsInCart) {
        productsInCart.forEach((el) => {
            const removeButton = el.querySelector('.Product-in-cart__rm-btn');
            removeButton.addEventListener('click', (e) => {
                e.preventDefault();
                const cartId = removeButton.dataset.cartId;
                const urlRemove = 'index.php?route=checkout/cart/remove';
                const urlTotals = 'index.php?route=checkout/cart/gettotals';

                const data = new FormData();
                data.append('key', cartId)
                fetch(urlRemove, {
                    method: 'POST',
                    body: data
                }).then((response) => {
                    if (!response.ok) {
                        throw new Error('Error occurred!')
                    }
                    return response.json();
                }).then((data) => {
                    console.log(data);
                    if (data.success) {
                        alertShow('success', 'Товар удалён из корзины!');
                        el.remove();
                        fetch(urlTotals).then((response) => {
                            if (!response.ok) {
                                throw new Error('Error occurred!')
                            }
                            return response.text();
                        }).then((html) => {
                            document.getElementById('totals-box').innerHTML = html;
                            const productsInCart = Number(document.getElementById('cartProductsQuantity').innerText);
                            document.getElementById('cartBtnCounter').innerText = productsInCart;
                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                }).catch((err) => {
                    console.log(err);
                });
            });
        });
    }
}

export default productInCartRemove;
